import { render, staticRenderFns } from "./sellEload.vue?vue&type=template&id=2bc4b0bb"
import script from "./sellEload.vue?vue&type=script&lang=js"
export * from "./sellEload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports